import { User } from "./types.user";

// Estados de FEV y RIPS
export enum EFEVRIPSStatus {
  Pending = 1,      // Preparado o creado localmente
  Sending = 2,      // Enviando
  Success = 3,      // Enviado correctamente
  Error = 4         // En error
}

// Opciones de AFacturar
export enum EAFacturarEnableOptions {
  FEV = 1,          // Solo Factura Electrónica
  FEV_RIPS = 2      // Factura Electrónica + RIPS
}

// Interface para notificaciones de FEV/RIPS via SignalR
export interface FEVRIPSNotification {
  Type: 'info' | 'success' | 'warning' | 'error';
  Title: string;
  Message: string;
  IdPreorden: number;
  Timestamp: string;
}

// Interface para el estado de FEV
export interface FEVState {
  POrd_FEV?: string | null;
  POrd_FEV_CUFE?: string | null;
  POrd_FEV_Estado?: EFEVRIPSStatus | null;
  POrd_FEV_FechaError?: string | null;
  POrd_FEV_FechaFactura?: string | null;
  POrd_FEV_FechaProcesado?: string | null;
  POrd_FEV_FechaProcesando?: string | null;
  POrd_FEV_FechaRegistro?: string | null;
  POrd_FEV_FechaVencimiento?: string | null;
  POrd_FEV_JSONResponse?: string | null;
  POrd_FEV_MensajeError?: string | null;
  POrd_FEV_Notas?: string | null;
  POrd_FEV_UID?: string | null;
  POrd_Nm_Id?: number | null;
  POrd_Nm_Numero?: string | null;
}

// Interface para el estado de RIPS
export interface RIPSState {
  POrd_RIPS_CUV?: string | null;
  POrd_RIPS_Estado?: EFEVRIPSStatus | null;
  POrd_RIPS_FechaError?: string | null;
  POrd_RIPS_FechaProcesado?: string | null;
  POrd_RIPS_FechaProcesando?: string | null;
  POrd_RIPS_FechaRegistro?: string | null;
  POrd_RIPS_MensajeError?: string | null;
  POrd_RIPS_MensajeErrorDIAN?: string | null;
  POrd_RIPS_JSONResponse?: string | null;
  POrd_RIPS_UID?: string | null;
}

export interface Preorden extends FEVState, RIPSState {
  POrd_Id: number;
  POrd_Pc_Id: number;
  POrd_Us_Id: number;
  POrd_Sd_Id: number;
  POrd_Se_Id?: number | null;
  POrd_Ord_Id?: number | null;
  POrd_FechaCreacion: string; 
  POrd_CamposDinamicos?: string | null;
  POrd_Importada: boolean;
  POrd_Estado: boolean;
  POrd_Cancelada: boolean;
}

export interface PreOrderState {
  Mode: 'new' | 'view' | 'update' | 'view' | 'loading';
  ModePatient: 'new' | 'view' | 'update' | 'view' | 'loading';
  PatientData: any | null;
  PreOrder: any | null;
  Notes: Notas[];
  IdPreOrder: number;
  ModalPatient: boolean;
  LoadingPatient: boolean;
  Loading: boolean;
}

export interface Notas {
  Npor_Id: number;
  Npor_Ord_Id: number;
  Npor_Us_Id: number;
  Npor_Fecha: Date;
  Npor_Nota: string;
  Usuarios: User;
}